import { Helmet } from "react-helmet-async";
import { useLocation, matchPath } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PAGE_META_MAP, SITE_NAME_KEY, DEFAULT_DESCRIPTION_KEY } from "@/config/pageMeta";

function resolvePageMeta(pathname: string) {
  const match = [...PAGE_META_MAP]
    .sort((a, b) => b.pattern.length - a.pattern.length)
    .find((entry) => matchPath({ path: entry.pattern, end: true }, pathname));
  return match?.meta ?? null;
}

/** Sets document title and description from the current route via react-helmet-async. */
export function DocumentMeta() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const siteName = t(SITE_NAME_KEY);
  const matched = resolvePageMeta(pathname);
  const title = matched ? t(matched.titleKey) : undefined;
  const description = matched ? t(matched.descriptionKey) : t(DEFAULT_DESCRIPTION_KEY);

  return (
    <Helmet titleTemplate={`%s | ${siteName}`} defaultTitle={siteName}>
      {title ? <title>{title}</title> : null}
      <meta name="description" content={description} />
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
}
